export const BLOCK_STATUSES = [
    { value: '603',  label: 'Call Declined' },
    { value: '603+', label: 'Network Blocked' },
    { value: '607',  label: 'Marked as Spam' },
    { value: '608',  label: 'Filter Rejected' },
]
